import React, { Component } from 'react'
import { connect } from 'react-redux'

import DealRoom from './component'
import CenteredSpinner from '../../Atoms/Spinner/CenteredSpinner'
import InlineError from '../../Atoms/InlineError'

import { fetchBid, submitBid, getImageDimensions } from '../../../redux/deals'

class DealRoomContainer extends Component {
  state = {
    bid: null
  }

  componentDidMount () {
    this.props.fetchBid(this.props.teamNumber, this.props.selectedRound)
    this.props.getImageDimensions(this.props.filesToDownload[`deals${this.props.selectedRound}.png`], this.props.sidebarWidth)
    this.pollChanges()
  }

  componentDidUpdate (prevProps) {
    if (this.props.selectedRound !== prevProps.selectedRound || this.props.roundNumber !== prevProps.roundNumber || this.props.teamNumber !== prevProps.teamNumber) {
      return this.props.fetchBid(this.props.teamNumber, this.props.selectedRound)
    }
  }

  componentWillUnmount () {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
      this.checkAndUpdate()
    }
  }

  shouldComponentUpdate (nextProps) {
    if (!nextProps.isCurrentTab) {
      return false
    }
    return true
  }

  pollChanges = () => {
    this.interval = setInterval(() => {
      this.checkAndUpdate()
    }, 5000)
  }

  checkAndUpdate = () => {
    if (!this.state.bid) {
      return
    }
    const { value, round } = this.state.bid
    this.props.submitBid(this.props.teamNumber, round, value)
    this.setState({ bid: null })
  }

  handleBidChange = (bid) => {
    this.setState({
      bid: {
        value: bid,
        round: this.props.selectedRound
      }
    })
  }

  render () {
    if (this.props.isLoading) {
      return <CenteredSpinner />
    }
    if (!this.props.imageDimensions) {
      return <CenteredSpinner />
    }
    if (this.props.error) {
      return <InlineError message={this.props.error.message} />
    }
    return (
      <DealRoom
        bid={this.props.bid}
        bidType={this.props.bidType}
        onBidChange={this.handleBidChange}
        canBid={this.props.isMaster && this.props.selectedRound === this.props.roundNumber}
        url={this.props.filesToDownload[`deals${this.props.selectedRound}.png`]}
        sidebarWidth={this.props.sidebarWidth}
        imageDimensions={this.props.imageDimensions}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  isCurrentTab: state.ui.currentTab === 'DealRoom',
  sidebarWidth: state.ui.sidebarWidth,
  selectedRound: state.game.selectedRound,
  teamNumber: state.team.id,
  roundNumber: state.game.currentRound,
  error: state.deals.error,
  isLoading: state.deals.isLoading,
  isLoaded: state.deals.isLoaded,
  bid: state.deals.bid,
  bidType: state.deals.bidType,
  isSubmitting: state.deals.isSubmitting,
  isMaster: state.device.isMaster,
  filesToDownload: state.files.filesToDownload,
  imageDimensions: state.deals.imageDimensions
})

export default connect(mapStateToProps, { fetchBid, submitBid, getImageDimensions })(DealRoomContainer)
